"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SvgBtClose = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _react = _interopRequireDefault(require("react"));

var SvgBtClose = function SvgBtClose(props) {
  return /*#__PURE__*/_react.default.createElement("svg", (0, _extends2.default)({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none"
  }, props), /*#__PURE__*/_react.default.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.18093 9.08991C8.93403 8.83478 8.9407 8.4278 9.19583 8.1809C9.45096 7.934 9.85794 7.94067 10.1048 8.1958L14.3574 12.5901L18.61 8.1958C18.8569 7.94067 19.2639 7.934 19.519 8.1809C19.7742 8.4278 19.7808 8.83478 19.5339 9.08991L15.252 13.5145L19.5334 17.9387C19.7803 18.1938 19.7737 18.6008 19.5185 18.8477C19.2634 19.0946 18.8564 19.0879 18.6095 18.8328L14.3574 14.439L10.1054 18.8328C9.85845 19.0879 9.45147 19.0946 9.19634 18.8477C8.9412 18.6008 8.93453 18.1938 9.18144 17.9387L13.4628 13.5145L9.18093 9.08991Z",
    fill: "currentColor"
  }));
};

exports.SvgBtClose = SvgBtClose;